exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .edit-item {\n  height: 100%; }\n  :host ::ng-deep .edit-item mat-form-field {\n    margin-bottom: unset !important; }\n    :host ::ng-deep .edit-item mat-form-field .mat-form-field-infix {\n      width: 320px; }\n  :host ::ng-deep .edit-item mat-dialog-actions {\n    margin-top: 20px; }\n  :host ::ng-deep .edit-item mat-dialog-actions:last-child {\n    margin-bottom: unset !important;\n    padding: unset !important; }\n\n@media screen and (max-width: 599px) {\n  mat-dialog-actions button:first-child {\n    margin-right: 6px; }\n  mat-dialog-actions button:last-child {\n    margin-left: auto;\n    -ms-flex: 1 1 50%;\n        flex: 1 1 50%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/create-audit-dialog/create-audit-dialog.component.scss
// module id = ../../../../../src/app/core/dialogs/create-audit-dialog/create-audit-dialog.component.scss
// module chunks = main